/**
 * The account schema as data, for building the editor form. The caller hands in the vendored
 * schema/account.schema.json (the bundler imports it), so the form and the types come from
 * one file.
 */
/** Front-of-form fields in display order; everything else is "advanced". */
export const PRIMARY_FIELDS = ['displayName', 'domain', 'username', 'password'];
/** Not shown in the form: the phone owns them. */
export const HIDDEN_FIELDS = new Set(['id', 'enabled']);
export function accountFields(schema) {
    const { properties, required: requiredList } = schema;
    const required = new Set(requiredList);
    return Object.entries(properties)
        .filter(([key]) => !HIDDEN_FIELDS.has(key))
        .map(([key, p]) => {
        const info = {
            key,
            type: fieldType(key, p),
            title: titleFor(key),
            description: String(p['description'] ?? ''),
            required: required.has(key),
            sensitive: p['x-sensitive'] === true,
        };
        if (Array.isArray(p['enum']))
            info.enumValues = p['enum'];
        if (key === 'codecs')
            info.enumValues = (p['items'].enum);
        if (typeof p['minimum'] === 'number')
            info.minimum = p['minimum'];
        if (typeof p['maximum'] === 'number')
            info.maximum = p['maximum'];
        if (typeof p['pattern'] === 'string')
            info.pattern = p['pattern'];
        if ('default' in p)
            info.defaultValue = p['default'];
        return info;
    });
}
function fieldType(key, p) {
    if (key === 'codecs')
        return 'codecs';
    if (Array.isArray(p['enum']))
        return 'enum';
    if (p['type'] === 'integer')
        return 'integer';
    if (p['type'] === 'boolean')
        return 'boolean';
    return 'string';
}
const TITLES = {
    displayName: 'Название', domain: 'Сервер', username: 'Логин', password: 'Пароль',
    authUsername: 'Логин авторизации', registrar: 'Регистратор', outboundProxy: 'Прокси',
    transport: 'Транспорт', port: 'Порт', srtp: 'Шифрование', registerIntervalSeconds: 'Перерегистрация, с',
    stunServer: 'STUN', codecs: 'Кодеки', trustedCertificateSha256: 'Доверенный сертификат',
};
function titleFor(key) {
    return TITLES[key] ?? key;
}
//# sourceMappingURL=schema.js.map